
import { Vue, Component, Inject } from "vue-property-decorator";
import { EMAIL_PUSH_CREATE, EMAIL_PUSH_EDIT } from "@/route-names";
import EventBus from "@models/eventBus";
import SendCustomMessageRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/NotificationService/SendCustomMessageRequest";

@Component
export default class PageEmailPushComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  columnNames = [
    "#",
    "Название",
    "Способ доставки",
    "Тип",
    ""
  ];
  isLoadingNewPush = false;
  isShowNewPushModal = false;
  createRouteName = EMAIL_PUSH_CREATE;
  editRouteName = EMAIL_PUSH_EDIT;
  getDataFunc = this.$api.NotificationService.getListAsync.bind(
    this.$api.NotificationService
  );
  showNewPushModal() {
    this.isShowNewPushModal = true;
  }
  async onSaveNewPush(item: SendCustomMessageRequest) {
    try {
      this.isLoadingNewPush = true;
      await this.$api.NotificationService.sendCustomMessageAsync(item);
      this.isShowNewPushModal = false;
      this.$notification.success('Рассылка прошла успешно');
    } catch (error) {
      this.$notification.error(error);
    } finally {
      this.isLoadingNewPush = false;
    }
  }
}
